export class LocationModel {
  latitude: number;
  longitude: number;

  constructor(model?: Partial<LocationModel>) {
    Object.assign(this, model);
  }
}
